import { render, staticRenderFns } from "./ListBody.vue?vue&type=template&id=704e30a0&scoped=true&"
import script from "./ListBody.vue?vue&type=script&lang=js&"
export * from "./ListBody.vue?vue&type=script&lang=js&"
import style0 from "./ListBody.vue?vue&type=style&index=0&id=704e30a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e30a0",
  null
  
)

export default component.exports